// Verificar si el usuario está autenticado
export const isAuthenticated = () => {
  const token = localStorage.getItem('authToken');
  const nickname = localStorage.getItem('userNickname');
  return !!(token && nickname);
};

// Función para cerrar sesión
export const logout = async () => {
  try {
    // Limpiar tokens del localStorage
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userNickname');
    
    // Opcional: Notificar al servidor sobre el logout
    // Esto se podría implementar llamando a la API de logout
    
    return true;
  } catch (error) {
    console.error("Error al cerrar sesión:", error);
    return false;
  }
};
